import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { SettingsInterceptor } from './settings-interceptor';

import { ErrorInterceptor } from './error-interceptor';
import { authInterceptor } from './auth-interceptor';

export * from './settings-interceptor';

export * from './error-interceptor';

export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: SettingsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useValue: authInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
];
